
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { TeacherProfilesTable } from './TeacherProfilesTable';
import { StudentPagination } from '@/components/admin/student-list/StudentPagination';
import { TeacherProfile } from '@/hooks/useTeacherProfiles';

interface TeacherProfilesResultsProps {
  profiles: TeacherProfile[];
  isLoading: boolean;
  totalCount: number;
  includeInactive: boolean;
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export const TeacherProfilesResults: React.FC<TeacherProfilesResultsProps> = ({
  profiles,
  isLoading,
  totalCount,
  includeInactive,
  currentPage,
  totalPages,
  onPageChange,
}) => {
  return (
    <Card>
      <CardHeader>
        <div className="flex justify-between items-center">
          <CardTitle>
            รายชื่อครู ({totalCount} คน)
            {includeInactive ? ' - รวมครูที่ไม่ใช้งาน' : ' - เฉพาะครูที่ใช้งาน'}
          </CardTitle>
        </div>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <TeacherProfilesTable
            profiles={profiles}
            isLoading={isLoading}
          />

          {totalPages > 1 && (
            <div className="flex justify-center">
              <StudentPagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={onPageChange}
              />
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
